jQuery( document ).ready(function(e) {
  if(!$('.discount').length){

    $('<tr class="discount"><th>Discount Applied</th><td data-title="Subtotal"><span class="shopify-Price-amount amount">$0.00</span></td></tr>').insertAfter('.shipping');
  }
  $('.template-cart .qty').change(function(){
    initCartProgressUpdate($(this), false);
  });

  jQuery('#helpClickme').on('click', function(ev){
    jQuery(this).siblings().toggleClass('displayItem');
    jQuery('.header-links .accout-child').removeClass('displayItem');
    ev.stopPropagation();
  });
  jQuery('.main-header .header-links #account-menu-parent').on('click', function(ex){
    jQuery(this).siblings().toggleClass('displayItem');
    jQuery('.help_parent .help_child').removeClass('displayItem');
    ex.stopPropagation();
  });
  jQuery(document).on('click', function(){
    jQuery('.help_parent .help_child').removeClass('displayItem');
    jQuery('.header-links .accout-child').removeClass('displayItem');
  });
  jQuery('#accordian-sec .gl_toggle').on('click', function(){
    jQuery(this).toggleClass('gl_toggle_active');
  });
  if($(window).width() < 768)
    $('.inside-section-container.desktop-only').remove();
  else
    $('.inside-section-container.mobile-only').remove();

  filterAccordion();
  videoplay();
  displayNewsletterPopUp();
  displayInstaFeed();
  removeAddedClass();
  clickCartAction();
  mobileCustomMenu();
  enableCartSearchAdd();
  mobielFillter();
  producerAccordian();

  initCartProgressUpdate('.template-cart .qty', true);
});

function initCartProgressUpdate(elem, onload){
    if($(elem).length){
        var parentRow = $(elem).closest('.cart_item');
        var remove = $(parentRow).find('.remove');
        var itemId = $(remove).attr('data-product_id');

        jQuery.post('/cart/update.js', "updates[" + itemId + "]="+ $(elem).val() +"",function(data){
            if(!onload){
                var items = $.grep(data.items, function(e){ return e.id == itemId; });  
                var originalPrice = $(parentRow).find('.product-price .amount');
                var lineAmount = $(parentRow).find('.product-subtotal .amount');
                if(items.length > 0){
                    $(originalPrice).text("$"+(items[0].original_price/100).toFixed(2));
                    $(lineAmount).text("$"+(items[0].original_line_price /100).toFixed(2));
                }
                else {
                    $(parentRow).remove();
                }
            }

            $('.cart-subtotal .amount').text("$"+(data.original_total_price/100).toFixed(2));
            $('.discount .amount').text("$"+(data.total_discount/100).toFixed(2));
            $('.order-total .amount').text("$"+(data.total_price/100).toFixed(2));
            
            window.to_free_shipping = window.free_shipping_amount - data.original_total_price;
            window.to_tier_1_discount =  window.tier_1_discount - data.original_total_price;
            window.to_tier_2_discount =  window.tier_2_discount - data.original_total_price;
            window.to_tier_3_discount = window.tier_3_discount - data.original_total_price;
            window.original_total_price = data.original_total_price;
            updateProgressBar();
        },"json");
    }
}

$(window).on('load resize', function() {
  $('.mobile-only .basel-products-tabs').each(function(){
    $(this).parent('.sbs-inside').css('width',$(this).find('.product-grid-item').outerWidth(true) * ($(this).find('.product-grid-item').length + 1.5));
  });
  equalheight('.equal-height');
  equalheightall('.product-grid-item .product-title');
  mobileSlider();
  getting_start_owl_carousel();

  $('.shopify-product-gallery .owl-item').each(function(){
    if($(this).find('figure').attr('data-thumb').indexOf("jpg") >= 0){
      $(this).css('padding','0');
    }
  });

  disCoverMobile();
});

$( document ).ajaxComplete(function() {
  equalheight('.equal-height');
  equalheightall('.product-grid-item .product-title');
  filterAccordion();
  cartOverLay();
  //enableCartSearchAdd();
  mobielFillter();
});

function cartProgressBar(){
  var min_free_shipping = '150';
  var progress_bar_colour = '#848484';
  var cart_total = 0;
  var amount_remaining_for_free_shipping = 0;
  var free_shipping_precentage = 0;

  var xhr = $.ajax({
    dataType: "json",
    url: '/cart.js',
    type: "GET",
    success: function(cart){
      console.log( "second success" );
      cart_total = cart.total_price;
      free_shipping_precentage = ((cart_total / 100)/min_free_shipping) * 100;

      if(free_shipping_precentage >= 100){
        free_shipping_precentage = 100;
        amount_remaining_for_free_shipping = 0;
        $('.free_shipping_msg').text('Score. Your order qualifies for free AU shipping.');
      }else{
        amount_remaining_for_free_shipping = min_free_shipping - (cart_total / 100);
        $('.amount_remaining_for_free_shipping').text(parseFloat(amount_remaining_for_free_shipping).toFixed(2));
      }
      if(min_free_shipping){
        $('.progress-bar').stop().animate({
          width: free_shipping_precentage + '%'
        }, 1000);
      }
    }
  });
}

function updateProgressBar(){
    let totier_one = (window.tier_1_discount - window.free_shipping_amount);
    let totier_two = (window.tier_2_discount - window.tier_1_discount);
    let totier_three = (window.tier_3_discount - window.tier_2_discount);

    var amountTotalNeeded;
    var free_shipping_percentage;

  if(window.to_free_shipping > 0 ){
    amountTotalNeeded = window.original_total_price +  window.to_free_shipping;
    free_shipping_percentage = (window.original_total_price/amountTotalNeeded);
    $(".progress_icon").html('<span class="icon-message float-right">\
<span class="main-message">\
<span class="bolder">Free</span> Delivery\
</span>\
<span class="icon-right free-shipping"></span>\
</span>');
    $('.progress_message').html('<span class="bolder">You are $' + ((window.to_free_shipping)/100).toFixed(2) + '</span> away from free shipping in AU.');

    if($('#shipping_method').length){
        $('#shipping_method').find('label').text('Shipping calculated at checkout');
    }
  }
  else if(window.to_tier_1_discount > 0){
    free_shipping_percentage = (totier_one - window.to_tier_1_discount)/totier_one;
    $(".progress_icon").html('<span class="icon-message float-left">\
<span class="icon-right free-shipping"></span>\
</span>\
<span class="icon-message float-right">\
<span class="main-message">\
<span class="bolder"></span> Off\
</span>\
<span class="icon-right cash"></span>\
</span>');
    $('.progress_message').html('<span class="bolder">Score. Your order qualifies for free AU shipping.</span> You are $' + ((window.to_tier_1_discount)/100).toFixed(2) + ' away from a  discount.');

    if($('#shipping_method').length){
        $('#shipping_method').find('label').text('Free Shipping (save $9)*');
    }
  }
  else if(window.to_tier_2_discount > 0){
    free_shipping_percentage = (totier_two - window.to_tier_2_discount)/totier_two;
    $(".progress_icon").html('<span class="icon-message float-left">\
<span class="icon-right cash"></span>\
<span class="main-message">\
<span class="bolder"></span> Off\
</span>\
</span>\
<span class="icon-message float-right">\
<span class="main-message">\
<span class="bolder"></span> Off\
</span>\
<span class="icon-right cash"></span>\
</span>');
    $('.progress_message').html('<span class="bolder">Score. Your order qualifies for free AU shipping.</span> You are $' + ((window.to_tier_2_discount)/100).toFixed(2) + ' away from a  discount.');
  }
  else if(window.to_tier_3_discount > 0){
    free_shipping_percentage = (totier_three - window.to_tier_3_discount)/totier_three;
    $(".progress_icon").html('<span class="icon-message float-left">\
<span class="icon-right cash"></span>\
<span class="main-message">\
<span class="bolder"></span> Off\
</span>\
</span>\
<span class="icon-message float-right">\
<span class="main-message">\
<span class="bolder">-1</span> Off\
</span>\
<span class="icon-right cash"></span>\
</span>');
    $('.progress_message').html('<span class="bolder">Score. Your order qualifies for free AU shipping.</span> You are $' + ((window.to_tier_3_discount)/100).toFixed(2) + ' away from a -1 discount.');
  }
  else if(window.original_total_price >= 150){
    free_shipping_percentage = 1;
    $(".progress_icon").html('<span class="icon-message centre-it-nice-one">\
<span class="party"></span>\
</span>');
    $('.progress_message').html('<span class="bolder">Score. Your order qualifies for free AU shipping.</span>');
                                }
                                $('.progress-bar').stop().animate({
      width: (free_shipping_percentage*100) + '%'
    });
  }


  function displayInstaFeed(){
    var InstaEnable = 'false';
    var userId = '263665037';
    var clientId = 'dd580f5b01254643a532c7c6570621e9';
    var accessToken = '263665037.dd580f5.aa75ed86a5344d33b70e263b60f1a7a1';
    var hashTagName = hashTag.substring(1);
    
    var feed = new Instafeed({
      get: 'tagged',
      tagName: hashTagName,
      userId: userId,
      clientId: clientId,
      accessToken: accessToken,
      limit: 4,
      resolution : 'low_resolution',
      template: '<li class="instaItem"><a href="{{link}}" target="_blank"></a><div class="wrapp-pics"><img src="{{image}}" alt="{{caption}}"/><div class="hover-mask"></div></div></li>'
    });
    if ($('ul#instafeed').length == 1 && InstaEnable == 'true'){
      feed.run();
    }
  }

  function displayNewsletterPopUp(){
    $('#sign_up_popup').on('click', function(e){
      e.preventDefault();
      $('.lc-overlay').fadeIn('fast', function(){
        $('.lc-promo-popup').addClass('active');
      });
    });
    $('.close').on('click', function(e){
      e.preventDefault();
      $('.lc-overlay').fadeOut('fast', function(){
        $('.lc-promo-popup').removeClass('active');
      });
    });
  }

  function filterAccordion(){
    $('.accordion-group').find('.widget-title').stop().on('click', function(e){
      //$('.accordion-group .sidebar-widget .widget-title').click(function(e) {
      e.stopImmediatePropagation();
      if($(this).parent().hasClass('active')){
        $(this).parent().removeClass('active');
        $(this).parent().find('div').first().slideUp('fast');
        $(this).parent().find('ul').first().slideUp('fast');
        return false;
      }else{
        $(this).parent().addClass('active');
        $(this).parent().find('div').css('height', 'auto').first().slideDown('slow');
        $(this).parent().find('ul').css('height', 'auto').first().slideDown('slow');
        return false;
      }

    });
    return false;

  }

  function equalheightall(container){
    var highestBox = 0;
    $(container).each(function(key, value){
      $(value).each(function(){
        if($(value).height() > highestBox) {
          highestBox = $(value).height();
        }
      });
      $(value).height(highestBox);
    });
  }

  equalheight = function(container){

    var currentTallest = 0,
        currentRowStart = 0,
        rowDivs = new Array(),
        $el,
        topPosition = 0;
    $(container).each(function() {

      $el = $(this);
      $($el).height('auto')
      topPostion = $el.position().top;

      if (currentRowStart != topPostion) {
        for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
          rowDivs[currentDiv].height(currentTallest);
        }
        rowDivs.length = 0; // empty the array
        currentRowStart = topPostion;
        currentTallest = $el.height();
        rowDivs.push($el);
      } else {
        rowDivs.push($el);
        currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
      }
      for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
    });
  }

  function mobileSlider(){
    var owl = $('.owl-carousel-mobile');
    if (owl.length == 1){
      if($(window).width() < 768){
        owl.owlCarousel({
          loop:true,
          margin:0,
          nav:false,
          navText: '',
          dots: true,
          responsive:{
            0:{
              items:1
            },
            991:{
              items:1
            },
            992:{
              items:3
            }
          }
        });
      }else{
        owl.trigger('destroy.owl.carousel');
      }
    }
  }

  /*about us*/
  function getting_start_owl_carousel(){
    var owl = $('.section-getting-start-main .owl-carousel');
    if (owl.length == 1){
      owl.owlCarousel({
        loop:true,
        margin:10,
        nav:false,
        responsive:{
          0:{
            items:1
          },
          600:{
            items:3
          },
          1000:{
            items:3
          }
        }
      });
    }
  }
  function videoplay(){
    //$("#section-about-us_iframe").fadeOut('slow');
    $("#video_section-about-us").on('click', function(event){
      $("#section-about-us_iframe").fadeIn('fast');
      $("#section-about-us_iframe")[0].src += "&autoplay=1";
    });
  }
  var player;
  function onYouTubePlayerAPIReady() {
    player = new YT.Player('section-about-us_iframe', {
      events: {
        onStateChange: onPlayerStateChange
      }
    });
  }

  function onPlayerStateChange(event) {
    if(event.data === 0) {
      console.log('done');
    }
    if(event.data === 1) {
      console.log('start');
    }
  }
  /*END*/

  function cartOverLay(){
    if($('.website-wrapper').hasClass('basel-wrapper-shifted')){
      var windowHeight = $(document).height();
      $('.basel-close-side').addClass('overlay-display');
      $('.basel-close-side').css('height', windowHeight);
    }else{
      $('.basel-close-side').removeClass('overlay-display');
    }
  }

  function removeAddedClass(){
    jQuery('.basel-close-side').on('click', function(){
      jQuery('.basel-close-side').removeClass('overlay-display');
    });
    jQuery('a.widget-close').on('click', function(){
      jQuery('.basel-close-side').removeClass('overlay-display');
    });
  }
  function clickCartAction(){
    jQuery('.shopping-cart a').on('click', function(){
      var windowHeight = $(document).height();
      $('.basel-close-side').addClass('overlay-display');
      $('.basel-close-side').css('height', windowHeight);
    });
  }

  //function ajaxcartUpdate(){
  //jQuery('.quantityContainer').find('input[type="button"]').on('click', function(){
  //var btn = jQuery(this);
  //console.log(jQuery(this));
  //setTimeout(function(){
  // var inputValue = jQuery(btn).parent().find('.qty').val();
  // console.log(inputValue);
  //},2000);
  //});
  //}

  function mobileCustomMenu(){
    jQuery('.mobilemMainParent a').on('click', function(){
      jQuery(this).next().find('ul.sub-menu').first().toggleClass('displayMenuItem');
      jQuery(this).next().next().toggleClass('up-icon');
    });
  }



  function enableCartSearchAdd(){
    jQuery('body').on('click', '.isp_add_to_cart_btn', function(){
      setTimeout(function(){
        jQuery.getJSON('/cart.js', function(cart) {
          $('.cartCount').html(cart.item_count),
            $(".basel-cart-subtotal >span").html(Shopify.formatMoney(cart.total_price, theme.moneyFormat))
        });
        jQuery.get('/cart?view=json', function(data) {
          /*optional stuff to do after success */
          $('.widget_shopping_cart_content').html(data);
        });
      }, 2000);

    }); 
  }

  function mobielFillter(){
    jQuery('#mobileVisiable .open-filters-customs').on('click', function(){
      $(this).toggleClass('btn-opened');
      $('#mobileVisiable').next().toggleClass('displayFillter');
    });
  }

  function producerAccordian(){
    jQuery('body').on('click','#mobile-accodian-sec .accodian-section-header', function(){
      jQuery(this).toggleClass('accodianActive');
      jQuery(this).next().toggleClass('accodian-display');
    });
  }

  function disCoverMobile(){
    var scrollposition = 0;
    var animateValue = '';
    var scrollAmount = $('.basel-products-tabs').find('.dragend-item').outerWidth(true) * 2;

    $('.navNext, .navPrev').on('click', function(e){
      e.preventDefault();
      if($(this).hasClass('navNext')){
        animateValue = '+=' + scrollAmount + 'px';
      }else{
        animateValue = '-=' + scrollAmount + 'px';
      }
      $(this).parents('.basel-products-tabs').find('.scroll-section').stop().animate({
        scrollLeft: animateValue
      }, "slow");
    });

    if($(window).innerWidth() > 991){
      $('.scroll-section').each(function(key, value){
        if($(value).find('.dragend-item').length <= 4){
          $(this).parents('.basel-products-tabs').find('.navBtn').hide();
        }
      });
    }
  }
